{
  "metadata": {
    "id": "tundra-dark",
    "name": "Tundra",
    "description": "Собственная тема Synth «Tundra» (dark)",
    "author": "Synth",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "synth",
      "own"
    ],
    "source": {
      "file": "tools/lib/make_themes.py",
      "project": "synth",
      "url": null,
      "upstreamFile": null,
      "license": "собственная (Synth)",
      "authoring": "tools/lib/make_themes.py"
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 21.2,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.334,
      "paletteMaxS": 0.369,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.1,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 19.5,
      "syntaxVsTextMinDeltaE": 22.9,
      "chartsMinDeltaE": 38.8,
      "textSeparationDeltaE": 22.9,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "comment",
          "b": "operator",
          "deltaE": 17.9
        },
        {
          "a": "keyword",
          "b": "type",
          "deltaE": 15.1
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#7FB069",
      "hover": "#8eb97b",
      "active": "#99c087",
      "foreground": "#000000",
      "muted": "#7fb06980",
      "emphasis": "#7FB069"
    },
    "surface": {
      "background": "#101613",
      "foreground": "#DCE5DC",
      "muted": "#242a27",
      "mutedForeground": "#9aa89a",
      "elevated": "#2c332f",
      "elevatedForeground": "#DCE5DC",
      "raised": "#454d48",
      "raisedForeground": "#DCE5DC",
      "overlay": "#101613cc",
      "subtle": "#1b221e"
    },
    "interactive": {
      "border": "#484f4a",
      "borderHover": "#49504b",
      "borderFocus": "#7FB069",
      "selection": "#dce5dc29",
      "selectionForeground": "#DCE5DC",
      "focus": "#7fb06959",
      "focusRing": "#7fb06961",
      "cursor": "#f2f7f2",
      "hover": "#dce5dc1c",
      "active": "#dce5dc29"
    },
    "status": {
      "error": "#D0594B",
      "errorForeground": "#000000",
      "errorBackground": "#d0594b24",
      "errorBorder": "#d0594b73",
      "warning": "#D9A404",
      "warningForeground": "#000000",
      "warningBackground": "#d9a40424",
      "warningBorder": "#d9a40473",
      "success": "#95C623",
      "successForeground": "#000000",
      "successBackground": "#95c62324",
      "successBorder": "#95c62373",
      "info": "#4E9A9A",
      "infoForeground": "#000000",
      "infoBackground": "#4e9a9a24",
      "infoBorder": "#4e9a9a73"
    },
    "pr": {
      "open": "#95C623",
      "draft": "#9aa89a",
      "blocked": "#D9A404",
      "merged": "#A7C957",
      "closed": "#D0594B"
    },
    "syntax": {
      "base": {
        "background": "#323935",
        "foreground": "#DCE5DC",
        "comment": "#97a497",
        "keyword": "#A7C957",
        "string": "#52B788",
        "number": "#E0A458",
        "function": "#7FB069",
        "variable": "#DCE5DC",
        "type": "#C2C15A",
        "operator": "#9AA89A"
      },
      "tokens": {
        "commentDoc": "#97a497",
        "stringEscape": "#9AA89A",
        "keywordImport": "#A7C957",
        "storageModifier": "#A7C957",
        "functionCall": "#7FB069",
        "method": "#7FB069",
        "variableProperty": "#7FB069",
        "variableOther": "#DCE5DC",
        "variableGlobal": "#E0A458",
        "variableLocal": "#9AA89A",
        "parameter": "#DCE5DC",
        "constant": "#E0A458",
        "class": "#C2C15A",
        "className": "#C2C15A",
        "interface": "#C2C15A",
        "struct": "#C2C15A",
        "enum": "#C2C15A",
        "typeParameter": "#C2C15A",
        "namespace": "#C2C15A",
        "module": "#A7C957",
        "tag": "#A7C957",
        "jsxTag": "#A7C957",
        "tagAttribute": "#7FB069",
        "tagAttributeValue": "#52B788",
        "boolean": "#E0A458",
        "decorator": "#A7C957",
        "label": "#7FB069",
        "regexp": "#52B788"
      }
    },
    "charts": {
      "series": [
        "#7FB069",
        "#4E9A9A",
        "#95C623",
        "#D9A404",
        "#D0594B"
      ]
    },
    "chat": {
      "background": "#101613",
      "userMessage": "#DCE5DC",
      "userMessageBackground": "#2c332f",
      "assistantMessage": "#DCE5DC",
      "assistantMessageBackground": "#242a27",
      "timestamp": "#9aa89a",
      "divider": "#484f4a",
      "typing": "#9aa89a"
    },
    "loading": {
      "spinner": "#7FB069",
      "spinnerTrack": "#242a27",
      "skeleton": "#242a27",
      "shimmer": "#3c433f"
    },
    "tools": {
      "background": "#242a27",
      "border": "#484f4a",
      "headerHover": "#3a423d",
      "icon": "#7FB069",
      "title": "#DCE5DC",
      "description": "#9aa89a",
      "edit": {
        "added": "#95C623",
        "addedBackground": "#95c62324",
        "removed": "#D0594B",
        "removedBackground": "#d0594b24",
        "modified": "#4E9A9A",
        "modifiedBackground": "#4e9a9a24",
        "lineNumber": "#9aa89a"
      }
    },
    "markdown": {
      "heading1": "#DCE5DC",
      "heading2": "#DCE5DC",
      "heading3": "#DCE5DC",
      "heading4": "#DCE5DC",
      "link": "#7FB069",
      "linkHover": "#8eb97b",
      "inlineCode": "#52B788",
      "inlineCodeBackground": "#242a27",
      "blockquote": "#9aa89a",
      "blockquoteBorder": "#484f4a",
      "listMarker": "#7fb069bf",
      "bold": "#DCE5DC",
      "italic": "#dce5dce6",
      "strikethrough": "#9aa89a",
      "hr": "#484f4a"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#ab5353",
        "foreground": "#ffffff",
        "contrast": 5.13
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#b68d81",
        "foreground": "#000000",
        "contrast": 7.12
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#b09059",
        "foreground": "#000000",
        "contrast": 6.98
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#d4d2a3",
        "foreground": "#000000",
        "contrast": 13.55
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#9bc27e",
        "foreground": "#000000",
        "contrast": 10.41
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#5db15a",
        "foreground": "#000000",
        "contrast": 7.9
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#679f7d",
        "foreground": "#000000",
        "contrast": 6.83
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#a2d3c2",
        "foreground": "#000000",
        "contrast": 12.63
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#5ba7b0",
        "foreground": "#000000",
        "contrast": 7.6
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#537dac",
        "foreground": "#000000",
        "contrast": 4.9
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#9eb2d0",
        "foreground": "#000000",
        "contrast": 9.73
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#4d50a7",
        "foreground": "#ffffff",
        "contrast": 6.95
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#9076bb",
        "foreground": "#000000",
        "contrast": 5.49
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#ad55a3",
        "foreground": "#ffffff",
        "contrast": 4.56
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#d09fc7",
        "foreground": "#000000",
        "contrast": 9.47
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#a15d7f",
        "foreground": "#ffffff",
        "contrast": 4.79
      }
    ]
  }
}
